import React from 'react';
import { DerivationStatus } from '../enums/DerivationStatus';

interface RadialSelectorProps {
  selectedView: DerivationStatus;
  setSelectedView: (view: DerivationStatus) => void;
}

export const RadialSelector: React.FC<RadialSelectorProps> = ({
  selectedView,
  setSelectedView,
}) => {
  return (
    <div className='flex w-full justify-center gap-2 px-1'>
      {[DerivationStatus.PENDING, DerivationStatus.ASSIGNED].map((status) => (
        <button
          key={status}
          className={`flex-1 min-w-fit px-4 py-2.5 rounded-full text-sm font-bold transition duration-300 shadow-md ${
            selectedView === status
              ? 'bg-orange-500 text-white'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }`}
          onClick={() => setSelectedView(status)}
        >
          {status === DerivationStatus.PENDING ? 'Pendientes' : 'Asignados'}
        </button>
      ))}
    </div>
  );
};
